import { useState } from 'react';
import classNames from 'classnames';

import lang from '../../../lib/language';
import { formatCurrency } from '../../../lib/util/DataHelpers';

import ChevronIcon from '../../../assets/img/chevron.svg';
import InfoIcon from '../../../assets/img/info-circle-blue.svg';
import { useIsMobile } from '../../../hooks';
import Button from '../../../shared_components/Button/Button';
import { BaseModal, ClickableDiv, MobileDrawer } from '../..';

import { PAYOUT_RULES, PAYOUT_RULES2 } from './payoutsRules.constants';

import styles from './PayoutsRules.module.scss';

type Props = {
  buyingPower?: number;
}

const PayoutsRules = ({
  buyingPower,
}: Props) => {
  const [showDropdown, setShowDropdown] = useState<boolean>(false);
  const { isMobile, isTablet } = useIsMobile();
  const isWeb = !isMobile && !isTablet;
  const rules = PAYOUT_RULES(buyingPower ? formatCurrency(buyingPower * 0.01) : '');
  const renderRules = () => (
    <>
      {!isMobile && <div className={styles.boldText}>{lang.initiatingWithdrawal()}</div>}
      {rules.map((rule) =>
        <p className={styles.dropdownText} key={rule}>{rule}</p>)}
      {!isMobile && <div className={styles.boldText}>{lang.afterRequest()}</div>}
      {PAYOUT_RULES2.map((rule, index) => (
        <p
          key={rule}
          className={classNames(styles.dropdownText,
            { [styles.lastRule]: index === PAYOUT_RULES2.length - 1 })}
        >
          {rule}
        </p>
      ))}
    </>
  );

  return (
    <div className={styles.container}>
      <ClickableDiv
        onClick={() => setShowDropdown(!showDropdown)}
        className={classNames(styles.dropdown, { [styles.dropdownActive]: showDropdown })}
      >
        <img src={InfoIcon} alt="i" />
        <div className={styles.dropdownTitleAndArrow}>
          <div>{lang.payoutRules()}</div>
          <img
            className={classNames(styles.chevron, { [styles.chevronActive]: showDropdown })}
            src={ChevronIcon}
            alt=""
          />
        </div>
      </ClickableDiv>
      {isWeb && (
        <div className={classNames(styles.dropdownBody, {
          [styles.dropdownBodyOpen]: showDropdown,
        })}
        >
          {renderRules()}
        </div>
      )}
      {isTablet && (
        <BaseModal isOpen={showDropdown} toggle={() => setShowDropdown(false)}>
          <div className={styles.rulesTitle}>{lang.payoutRules()}</div>
          {renderRules()}
          <Button
            biggerFontSize
            className={styles.closeButton}
            onClick={() => setShowDropdown(false)}
          >
            {lang.commonClose()}
          </Button>
        </BaseModal>
      )}

      {isMobile && (
        <MobileDrawer isOpen={showDropdown} onClose={() => setShowDropdown(false)} title={lang.payoutRules()}>
          <div className={styles.mobileContainer}>
            {renderRules()}
            <Button
              fullWidth
              biggerFontSize
              className={styles.closeButton}
              onClick={() => setShowDropdown(false)}
            >
              {lang.commonClose()}
            </Button>
          </div>
        </MobileDrawer>
      )}
    </div>
  );
};

export default PayoutsRules;
